<script>
	import Svelecte from "svelecte";

	export let conditions;
	let randomizeCardsBetweenSubjects = ["yes"];
	let entitySets = JSON.parse(
		localStorage.getItem("createStudyPulledEntitySets")
	);
	let entitySetsCopy = entitySets;
	let showError = false;
	if (!entitySets) showError = true;
	let cardCategories = entitySets.cardCategories;

	let selectionSets = [];
	let selectedSets = [];
	let selectedSetsParsed = {};

	const updateSelectedSets = (cardCategory, conditionidx) => {
		const sets = selectionSets[conditionidx][cardCategory];
		selectedSets[conditionidx][cardCategory] = sets.map((s) => s.label);
		console.log("selectedSets:", selectedSets);

		if (conditions == 0) {
			selectedSetsParsed = {};
			return;
		}

		// loop through objects/sets in conditions
		selectedSets.forEach((conditionSets, csi) => {
			let entities = [];
			for (const key in conditionSets) {
				let set = conditionSets[key];
				set.forEach((si) => {
					// catch weird bug with Svelecte
					if (Object.keys(si).includes("label")) {
						si = si["label"];
					}
					console.log("csi si", csi, si);
					const setname = si.slice(0, si.indexOf(" ["));
					const maxCards = entitySetsCopy["entity_set_n"][setname];
					let obj = {
						entity_set: setname,
						number_to_show: maxCards,
						randomize_between_subjects:
							randomizeCardsBetweenSubjects[csi],
					};
					entities.push(obj);
				});
			}
			selectedSetsParsed[csi] = entities;
		});
		console.log("selectedSetsParsed:", selectedSetsParsed);
		updateStorage();
	};

	const updateSelectedSetValues = (setName, conditionidx, numberToShow) => {
		const sets = selectedSetsParsed[conditionidx];
		for (let j = 0; j < sets.length; j++) {
			if (sets[j]["entity_set"] === setName) {
				selectedSetsParsed[conditionidx][j]["number_to_show"] =
					numberToShow;
				selectedSetsParsed[conditionidx][j][
					"randomize_between_subjects"
				] = randomizeCardsBetweenSubjects[conditionidx];
			}
		}
		console.log("selectedSetsParsed:", selectedSetsParsed);
		updateStorage();
	};

	const updateRandomizeCards = (conditionidx) => {
		const sets = selectedSetsParsed[conditionidx];
		for (let j = 0; j < sets.length; j++) {
			selectedSetsParsed[conditionidx][j]["randomize_between_subjects"] =
				randomizeCardsBetweenSubjects[conditionidx];
		}
		console.log("selectedSetsParsed:", selectedSetsParsed);
		updateStorage();
	};
	$: if (conditions >= 0) {
		if (conditions === 0) {
			randomizeCardsBetweenSubjects = [];
		}
		if (conditions > randomizeCardsBetweenSubjects.length) {
			randomizeCardsBetweenSubjects.push("yes");
		}
		if (randomizeCardsBetweenSubjects.length > conditions) {
			randomizeCardsBetweenSubjects.pop();
		}
		console.log(
			"randomizeCardsBetweenSubjects",
			randomizeCardsBetweenSubjects
		);
	}

	const updateSelected = (conditions) => {
		if (conditions == 0) {
			selectionSets = [];
			selectedSets = [];
			console.log("selectionSets updated", selectionSets);
			console.log("selectedSets updated", selectedSets);
			return;
		}
		const condAdd = conditions - selectedSets.length;
		console.log("conditions:", conditions);
		console.log("condAdd:", condAdd);
		if (condAdd > 0) {
			for (let c = 0; c < condAdd; c++) {
				let temp_selectionSets = {};
				let temp_selectedSets = {};
				for (let i = 0; i < cardCategories.length; i++) {
					temp_selectionSets[cardCategories[i]] = [];
					temp_selectedSets[cardCategories[i]] = [];
				}
				selectionSets.push(temp_selectionSets);
				selectedSets.push(temp_selectedSets);
				selectedSetsParsed[conditions - 1] = [];
			}
		} else if (condAdd < 0) {
			selectionSets = selectionSets.slice(0, conditions);
			selectedSets = selectionSets.slice(0, conditions);
			delete selectedSetsParsed[conditions];
		}
		console.log("selectionSets updated", selectionSets);
		console.log("selectedSets updated", selectedSets);
		console.log("selectedSetsParsed:", selectedSetsParsed);
	};
	$: updateSelected(conditions);

	const getConditionSets = () => {
		let obj = {};
		for (let c = 0; c < conditions; c++) {
			// unpack/merge arrays
			let temp = [].concat.apply([], Object.values(selectedSets[c]));
			const tempKey = "condition-" + (c + 1) + ";entity-sets";
			obj[tempKey] = temp;
		}
		console.log("formatted entity_sets", obj);
		return obj;
	};

	const updateStorage = () => {
		let params = localStorage.getItem("createStudyParams");
		if (params) {
			params = JSON.parse(params);
		} else {
			params = {};
		}
		params["selectionSets"] = selectionSets;
		params["selectedSets"] = selectedSets;
		params["selectedSetsParsed"] = selectedSetsParsed;
		localStorage.setItem("createStudyParams", JSON.stringify(params));
	};

	const formatForAPI = (conditions, parameters, parameterName) => {
		let paramsSelected = JSON.parse(
			localStorage.getItem("createStudyParamsSelected")
		);
		let formatted = [];
		for (let i = 0; i < conditions; i++) {
			formatted.push({
				condition: i + 1,
				param: parameterName,
				value: parameters[i],
			});
		}
		if (paramsSelected) {
			paramsSelected[parameterName] = formatted;
		} else {
			paramsSelected = {};
			paramsSelected[parameterName] = formatted;
		}
		localStorage.setItem(
			"createStudyParamsSelected",
			JSON.stringify(paramsSelected)
		);
	};
	$: formatForAPI(conditions, selectedSetsParsed, "entity_sets");
</script>

<hr />
{#if showError}
	<p>There was an error loading the entity sets</p>
{:else}
	<h3>Cards</h3>
	<p>Number of cards in each entity set are in brackets</p>

	{#each { length: conditions } as _, i}
		<p><strong>Condition {i + 1}</strong></p>

		{#each entitySets.cardCategories as category, j}
			<p style="font-size:0.9em;">Category: {category}</p>
			<Svelecte
				options={entitySets.entity_sets[category]}
				bind:readSelection={selectionSets[i][category]}
				on:change={() => updateSelectedSets(category, i)}
				multiple
				placeholder={"Select set(s) for " + category + " cards"}
				style="width:100%"
			/>
		{/each}

		{#if Object.keys(selectedSetsParsed).length > 0}
			{#if selectedSetsParsed[[i]] !== undefined && selectedSetsParsed[[i]].length > 0}
				<p style="font-size:0.9em;">
					<em
						>Optional: Indicate how many card to randomly select
						from each set (default is all)
					</em>
				</p>

				{#each selectedSetsParsed[i] as set, seti}
					<span style="font-size:0.8em">
						<label
							for={"condition-" +
								(i + 1) +
								";numCards-" +
								set.entity_set}
							class="card-label">{set.entity_set}</label
						>
						<input
							name={"condition-" +
								(i + 1) +
								";numCards-" +
								set.entity_set}
							type="number"
							list="button-options"
							class="button-input"
							min="1"
							max={entitySetsCopy["entity_set_n"][set.entity_set]}
							style="width: 70px;"
							bind:value={selectedSetsParsed[i][seti]
								.number_to_show}
							on:change={() =>
								updateSelectedSetValues(
									set.entity_set,
									i,
									selectedSetsParsed[i][seti].number_to_show
								)}
						/>
					</span>
				{/each}

				<p style="font-size:0.9em;">
					<em
						>Optional: Randomly subsample different cards for
						different participants? (default is yes)</em
					>
				</p>

				<label for={"condition-" + (i + 1) + ";numCards"} />
				<select
					name={"condition-" + (i + 1) + ";numCards"}
					bind:value={randomizeCardsBetweenSubjects[i]}
					on:change={() => updateRandomizeCards(i)}
				>
					<option value="yes">yes</option>
					<option value="no">no</option>
				</select>
			{/if}
		{/if}
	{/each}
{/if}

<style>
	.card-label {
		display: inline;
	}
</style>
